import React from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";
import {
    StandardModalDescription,
    StandardModalLabel,
    StandardModalSectionTitle,
    portalColors
} from "src/components";

const RequestDocumentsHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
`;

const RequestDocumentsDescription = styled.div`
    margin-bottom: 16px;
    margin-left: 33px;
`;

const DocumentsTitle = styled(StandardModalSectionTitle)`
    margin-bottom: 8px;
    margin-left: 33px;
`;

const DocumentsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 33px;
`;

const DocumentItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const Checkbox = styled.input.attrs({ type: "checkbox" })`
    width: 16px;
    height: 16px;
    accent-color: ${portalColors.text};
    opacity: 1;
    cursor: pointer;
`;

const DocumentName = styled.span`
    font-size: 14px;
    color: ${portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 600;
`;

const RequestDocumentsSection = ({
    formData = {},
    setFormData = () => {},
    documentTypes = [],
    selectedDocuments = [],
    setSelectedDocuments = () => {},
    hideHeaderCheckbox = false,
    openRequestDocumentsModal = () => {}
}) => {
    
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <RequestDocumentsHeader>
                    <Checkbox
                        checked={
                            formData.requestDocuments ||
                            (formData.selectedDocuments || selectedDocuments || []).length > 0
                        }
                        onChange={(e) => {
                            const checked = e.target.checked;

                            if (formData.selectedDocuments !== undefined) {
                                setFormData({
                                    ...formData,
                                    requestDocuments: checked,
                                    selectedDocuments: checked
                                        ? formData.selectedDocuments || []
                                        : []
                                });
                            } else {
                                setSelectedDocuments(checked ? documentTypes.map(document => document.uuid) : []);
                            }
                        }}
                    />

                    <StandardModalLabel>
                        Requested User Documents (Optional)
                    </StandardModalLabel>
                </RequestDocumentsHeader>

                <RequestDocumentsDescription as={StandardModalDescription}>
                    Change or remove documents that you have requested
                    from this user.
                </RequestDocumentsDescription>

                <DocumentsTitle>
                    Documents
                </DocumentsTitle>

                <DocumentsList>
                    {documentTypes.map((document) => (
                        <DocumentItem key={document.uuid}>
                            <Checkbox
                                checked={
                                    (formData.selectedDocuments || selectedDocuments || []).includes(document.uuid)
                                }
                                onChange={(e) => {
                                    const selected = formData.selectedDocuments || selectedDocuments || [];
                                    const updated = e.target.checked
                                        ? [...selected, document.uuid]
                                        : selected.filter(
                                            (id) => id !== document.uuid
                                        );

                                    if (formData.selectedDocuments !== undefined) {
                                        setFormData({
                                            ...formData,
                                            selectedDocuments: updated
                                        });
                                    } else {
                                        setSelectedDocuments(updated);
                                    }
                                }}
                            />

                            <DocumentName>
                                {document.description}
                            </DocumentName>
                        </DocumentItem>
                    ))}
                </DocumentsList>
            </Grid>
        </Grid>
    );
};

export default RequestDocumentsSection;
